class Tracker {

    static pixelEvent(code, data) {
        if (typeof fbq === 'undefined') {
            console.log('fbq is undefined');

            return;
        }

        console.log('%c fbq trackCustom: ', 'background: #000; color: #a78bfa;', code, data);

        fbq('trackCustom', code, data);
    }

    static pixelPageOpen(code) {
        this.pixelEvent(`pageview_${code}`);
    }

    static matomoEvent(category, action, name, value) {
        if (typeof window._paq === 'undefined') {
            console.log('window._paq is undefined');

            return;
        }

        console.log('%c matomo trackEvent: ', 'background: #000; color: #a78bfa;', category, action, name, value);

        if (typeof value !== 'undefined') {
            window._paq.push(['trackEvent', category, action, name, value]);
            return;
        }

        window._paq.push(['trackEvent', category, action, name]);
    }

    static matomoPoliticianEmailed(name) {
        this.matomoEvent('Selection', 'Politician emailed', name);
    }

}

export default Tracker;
